export default "__VITE_ASSET__29f1832c__"